// extracted by mini-css-extract-plugin
export default {"breakpointDetails":"820","breakpointDetailsHalf":"410","breakpointOtherTabs":"820","breakpointOtherTabsHalf":"410","maxPaneWidth":"1300","gridGap":"16"};